import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import IBISRegistrationDetails from "./routes/IBISRegistrationDetails";
import EditInformation from "./routes/EditInformation";

export default store => ({
  path: "ibis-registration",
  exact: true,
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "ibis-registration" */ "./components"),
        import(
          /* webpackChunkName: "ibis-registration" */ "DPExamRegistration/modules/DPExamRegistrationModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "dpExamReg",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [IBISRegistrationDetails(store), EditInformation(store)],
});
